import type { InputProps } from '@chakra-ui/react'
import { Field, Input } from '@chakra-ui/react'

interface FormInputProps extends InputProps {
  error?: string
  description?: React.ReactNode
  isRequired?: boolean
}

function FormInput(props: FormInputProps) {
  const { error, description, isRequired, placeholder, ...rest } = props

  return (
    <Field.Root invalid={!!error} required={isRequired}>
      <Input {...rest} placeholder={placeholder ?? ''} />
      {error ? (
        <Field.ErrorText color="red.600" fontSize="12px">
          {error}
        </Field.ErrorText>
      ) : null}
      {description && !error ? description : null}
    </Field.Root>
  )
}

export default FormInput
